import classes from "./cpcSearchBar.scss";
import SceErrorBox from "../../../Common/ErrorBox/sceErrorBox";
import SceSelectBox from "./cpcSearchDropDown";
import { getLocalizedStringstwo } from "../../../Centralized/centralizedLocalizedStringtwo";
import ErrorBox from "./searchError";
class UISearchBar extends React.Component {
  constructor(props) {
    super(props);
    this.strings = getLocalizedStringstwo('SearchBarSection'); 
    this.state = {
      searchText: "",selectedType:"", dropDownError: false,resetDropdown:false,disableButton:true,
      error: { isError: false, errorMessage: "" },
      options:[
        {value:'streetNumber',name:this.strings.streetNumber},
        {value:'streetName',name:this.strings.streetName},
        {value:'city',name:this.strings.city},
        {value:'zip',name:this.strings.zip},
        {value:'contractAccountNumber',name:this.strings.accountNumber},
      ]
    };
  }

  componentDidUpdate(prevProps, prevState){
      if (prevProps.searchText !== this.props.searchText || prevProps.selectedType !== this.props.selectedType){
        this.setState({searchText: this.props.searchText, selectedType: this.props.selectedType === 'contractNumber' ? 'contractAccountNumber' : this.props.selectedType, resetDropdown: !this.state.resetDropdown});
      }
  }
  
  findTextType = (searchText) => {
    let searchType="";
    if(this.state.selectedType === "contractAccountNumber")
    { if ( searchText !== null &&
      searchText.match(/^[0-9]+$/) &&
      searchText.length === 12 &&
      (searchText.substring(0, 3) === "600" ||
        searchText.substring(0, 3) === "700")
    ) {
      searchType = "contractAccountNumber";
    } else if (
      searchText !== null &&
      searchText.match(/^[0-9]+$/) &&
      searchText.length === 10 &&
      searchText.substring(0, 1) === "8"
    ) {
      searchType = "contractNumber";
    } 
    
  }

    else{
      searchType = this.state.selectedType;
    }
    return searchType;
  };
  //handing drop down
  dropDownHandler = (e) => {
    this.setState({selectedType:e.value,dropDownError:false,resetDropdown:false,disableButton:false});

  }
  getplaceholder = () =>{
    switch (this.state.selectedType) {
      case "zip": return this.strings.zipPlaceholder;
      case "city":return this.strings.cityPlaceholder;
      case "contractAccountNumber":return this.strings.accountNumberPlaceholder;
      case "streetName": return this.strings.streetNamePlaceholder;
      case "streetNumber": return this.strings.streetNumberPlaceholder;
      default:return  this.strings.searchPlaceholder;
    }

  }
  //Filters the data as per the search text.
  searchAccountsHandler(searchText) {
    let updatedSearchDataState = { ...this.state };
    let searchType = this.findTextType(searchText); //"selected value from the dropdown 
    if (searchText === "" || searchType === "") {
      updatedSearchDataState.error.isError = true;
      updatedSearchDataState.error.errorMessage =
        "No accounts matched your search. You can search by exact city name, zip, or account number.";
        this.setState(updatedSearchDataState, () => {
          this.props.filterSearchedCactList(searchText, searchType, "error", 0);
        });
    } else {
      updatedSearchDataState.error.isError = false;
      this.setState(updatedSearchDataState, () => {
        this.props.filterSearchedCactList(searchText, searchType, "search", 0);
      });
    }
    this.setState(updatedSearchDataState);
  }

  /**
   * Handles the events on search bar.
   * @param {*String} searchText
   * @param {*String} action
   */
  handleSearchEvents(event, searchText, action) {
    
    app.logger.getLogger().info(action);
    let searchType = this.findTextType(searchText);//"selected value from the dropdown 
    if (action === "onChange") {
    if(!_.isEmpty(this.state.selectedType)){
        if(this.state.selectedType==="contractAccountNumber"){
              const  re = new RegExp(/^\d{0,12}$/);
              if(!re.test(searchText)) { 
              return event.preventDefault();}
            }
            
            else if(searchType === "zip" ){
              const r  =new RegExp(/^\d{0,5}$/);
              if(!r.test(searchText)) { 
              return event.preventDefault();}
            }
      let updatedSearchDataState = { ...this.state };
      updatedSearchDataState.searchText = searchText;
      this.setState(updatedSearchDataState);
    }
    else{
      this.setState({dropDownError:true});
     }
    } else if (action === "onClear") {
      let errorVar = { isError: false, errorMessage: "" };
      this.setState({ searchText: "", error: errorVar,selectedType:"",resetDropdown:!this.state.resetDropdown}, () => {
        this.props.filterSearchedCactList("", searchText, "clear", 0);
      });   
    } else if (action === "onBlur") {
  
      if (searchText === "") {
        let errorVar = { isError: false, errorMessage: "" };
        this.setState({ searchText: "", error: errorVar }, () => {
          this.props.filterSearchedCactList("", searchText, "clear", 0);
        });
      }
    } else if (action === "onSubmit") {
       if((this.state.selectedType==="")||searchText ===""){
        this.setState({disableButton:true});}
       else{
        window.aUtils.sendAAEvent("button",searchType +"search");
        this.searchAccountsHandler(searchText);}
      
    } else if (action === "onKeyPress" && event.key === "Enter") {
       if((this.state.selectedType==="")||searchText ===""){
         this.setState({disableButton:true});
        }
       else{
          window.aUtils.sendAAEvent("enterKey",searchType + "search");
          this.searchAccountsHandler(searchText);}
     }
  }
  render() {
    let SelectError = this.state.dropDownError ?<ErrorBox message={this.strings.searchError} />: null;
    let placeholder = this.getplaceholder();
    const clearIconJSX = !this.state.searchText ? null : (
      <button
        type="button"
        className={classes.sceSACTClearButton}
        onClick={(event) => this.handleSearchEvents(event, "", "onClear")}
        aria-label="Clear the search"
        title="Clear"
      >
        <span className={classes.hiddencpc}><i className={"fas fa-lg fa-times " + classes.sceClearIcon} /></span>
        <span className={classes.visiblecpc}><i className={"fas fa-xs fa-times " + classes.sceClearIcon} /></span>

      </button>
    );

    let searchBar = (
      <div className={"row " + classes.sceSearchBarSection}>
        {" "}
        <div className="col-sm-12">
          <div className={classes.dropDown}>
             <SceSelectBox 
              id={"dropdown"}
               selectBoxData={this.state.options}
               handleClick={this.dropDownHandler}
               displayDefaultText={false}
               defaultValue={this.state.selectedType}
               selected={this.state.selectedType} 
               resetDropdown={this.state.resetDropdown}
                 />  
          </div>
          <div className={classes.sceSearchBox}>
            {/* Change type : New UI requirment
            Changed by: Ramya Venkata
            Date : 19-05-2020 */}
            <input
              type="text"
              id="searchServiceAccounts"
              aria-label={placeholder}
              maxlength="30"
              className={classes.sceSearchBar}
              placeholder={placeholder}
              value={this.state.searchText}
              onBlur={(event) =>
                this.handleSearchEvents(event, event.target.value, "onBlur")
              }
              onKeyPress={(event) =>
                this.handleSearchEvents(event, event.target.value, "onKeyPress")
              }
              onChange={(event) =>
                this.handleSearchEvents(event, event.target.value, "onChange")
              }   
            />
            {clearIconJSX}
            <button
              type="submit"
              className={classes.sceSACTSearchButton}
              aria-label="Search"
              title="Search"
              isDisabled={(this.state.disableButton) ? true : false} 
              onClick={(event) =>
                this.handleSearchEvents(
                  event,
                  this.state.searchText,
                  "onSubmit"
                )             
              }
            >
             <span className={classes.hiddencpc}><i className={"fas fa-lg fa-search " + classes.sceSearchIcon} /></span>
              <span className={classes.visiblecpc} ><i className={"fas fa-xs fa-search " + classes.sceSearchIcon} /></span>
            </button>
          </div>
          <span className={classes.searchError}>{SelectError}</span>
          {/* <SceErrorBox
            isError={this.state.error.isError}
            errorMessage={this.state.error.errorMessage}
          /> */}
        </div>
      </div>
    );

    return <div>{searchBar}</div>;
  }
}

export default UISearchBar;
